// removed by extract-text-webpack-plugin
module.exports = {"divider":"_3iDGiEv70AjhuuRck4-3Zj","noLine":"_96F1Ts41bFzC_ZA7A47vu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Divider/index.module.less
// module id = 756
// module chunks = 0